<app-dialog-header [title]="dialogTitle" (onCancel)="onCancel()" />

<mat-dialog-content class="order-guide-dialog__content">
  <form [formGroup]="form" class="order-guide-dialog__form">
    <section class="order-guide-dialog__derived">
      <h3 class="order-guide-dialog__section-title">Dates</h3>
      <div class="order-guide-dialog__date-row">
        <app-date-picker
          formControlName="activeDate"
          [control]="getControl('activeDate')"
          label="Active Date" />

        <app-date-picker
          formControlName="sorpDate"
          [control]="getControl('sorpDate')"
          label="SORP Date" />
      </div>

      @if (showTranslationDate) {
        <app-date-picker
          formControlName="translationDate"
          [control]="getControl('translationDate')"
          label="Send for Translation" />
        <p class="note">
          Defaults to 21 days before the Active Date. Change it for an early or late submission.
        </p>
      }

      <div class="order-guide-dialog__live-date">
        <span class="order-guide-dialog__live-date-label">Live Date</span>
        <span class="order-guide-dialog__live-date-value">{{ liveDateDisplay }}</span>
        <span class="note order-guide-dialog__live-date-hint">
          Live Date is four days after the Active Date.
        </span>
      </div>
    </section>
  </form>

  <section class="order-guide-dialog__notes">
    <app-order-guide-notes-section [notes]="notes()" (notesChange)="onNotesChange($event)" />
  </section>

  <section class="order-guide-dialog__attachments">
    <div class="order-guide-dialog__header">
      <button
        type="button"
        class="order-guide-dialog__toggle"
        [attr.aria-expanded]="attachmentsExpanded()"
        aria-controls="order-guide-attachments-body"
        (click)="toggleAttachments()"
      >
        <mat-icon class="order-guide-dialog__toggle-icon" aria-hidden="true">
          {{ attachmentsExpanded() ? 'expand_less' : 'expand_more' }}
        </mat-icon>
        <span class="order-guide-dialog__section-title order-guide-dialog__section-title--inline">
          Attachments
        </span>
        @if (attachments().length) {
          <span class="order-guide-dialog__count">({{ attachments().length }})</span>
        }
      </button>

      <button
        type="button"
        mat-mini-fab
        class="order-guide-dialog__add-btn"
        matTooltip="Add attachment"
        aria-label="Add attachment"
        [attr.aria-expanded]="attachmentAddVisible()"
        aria-controls="order-guide-attachments-add"
        (click)="toggleAttachmentAdd($event)"
      >
        <mat-icon>add</mat-icon>
      </button>
    </div>

    @if (attachmentsExpanded()) {
      <div id="order-guide-attachments-body" class="order-guide-dialog__attachments-body">
        @if (attachments().length) {
          <ul class="order-guide-dialog__file-list">
            @for (file of attachments(); track file.id) {
              <li class="order-guide-dialog__file">
                <a [href]="attachmentUrl(file)" target="_blank" rel="noopener">{{ file.fileName }}</a>
                <button-delete
                  [toolbar]="true"
                  matTooltip="Remove attachment"
                  (onClick)="onRemoveAttachment(file)" />
              </li>
            }
          </ul>
        } @else {
          <p class="note">No attachments yet.</p>
        }

        @if (attachmentAddVisible()) {
          <app-file-drop-zone
            id="order-guide-attachments-add"
            accept=""
            label="Drop order guide files"
            [multiple]="true"
            [fullWidth]="true"
            (filesPicked)="onAddAttachments($event)" />
        }
      </div>
    }
  </section>
</mat-dialog-content>

<mat-dialog-actions align="end" class="order-guide-dialog__actions">
  <button-cancel (onClick)="onCancel()" />
  <button-save [disabled]="saving() || !hasChanges" (onClick)="onSave()" />
</mat-dialog-actions>
